export type Duration = {
  years?: number;
  months?: number;
  weeks?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
};

export type PrecisionTypes =
  | 'month'
  | 'week'
  | 'day'
  | 'calendarDay'
  | 'hour'
  | 'minute'
  | 'second'
  | 'millisecond';

export enum DateFormat {
  Date = 'dd-MM-yyyy',
  DateReverse = 'yyyy-MM-dd',
  ShortMonthAndYear = 'MMM yyyy',
  DateWithShortMonth = 'd MMM yyyy',
  DateWithFullMonth = 'd MMMM yyyy',
  Time = 'HH:mm',
  Day = 'd',
  DateMonth = 'd MMM',
  DateFullMonthName = 'd MMMM',
  MonthShortName = 'MMM',
  DateMonthWithDot = 'd. MMM',
  DateTime = 'd MMM, HH:mm',
  FullDateTime = 'dd-MM-yyyy HH:mm',
  FullDayName = 'EEEE',
  ShortDayName = 'EEEEEE',
  MonthFullName = 'LLLL',
  FullYear = 'yyyy',
  CnxFormat = 'yyyy-MM-dd HH:mm',
  ISO = "yyyy-MM-dd'T'HH:mm:ss",
  DayAndShortDate = 'eee, d',
  DayShortMonthShortYear = 'eee, d MMM yyyy',
  DayShortMonthShort = 'eee, d MMM',
  FullMonthAndYear = 'MMMM, yyyy',
}

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export type MonthIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
